export default __webpack_public_path__ + "static/iron_steel_prices-6b1f341ffd155fe4e74ec608ed3e8588.png";